import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { FormGroup, Grid } from "@mui/material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Select from "@mui/material/Select";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from "@mui/material/Checkbox";
import CheckIcon from "@mui/icons-material/Check";
import CancelIcon from "@mui/icons-material/Cancel";
import Box from "@mui/material/Box";
import { useNavigate, useParams } from "react-router-dom";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import _ from "lodash";
import { enqueueSnackbar } from "notistack";

export default function EditRole() {
  const [loading, setLoading] = React.useState(false);
  const axios = useAxiosPrivate();
  const [permissions, setPermissions] = React.useState([]);
  const [permissionName, setPermissionName] = React.useState([]);

  const [name, setName] = React.useState("");

  const endpoint = "role";
  const rolesViewUrl = "/roles";

  const permissionsEndpoint = "module/all";

  const { REACT_APP_BASE_API_URL } = process.env;
  const navigate = useNavigate();
  const { id } = useParams();

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const updateRole = (e) => {
    e.preventDefault();
    axios
      .patch(`${REACT_APP_BASE_API_URL}/${endpoint}/${id}`, {
        permissions: _.join(permissionName, ","),
        role_name: name,
      })
      .then((res) => {
        if (res.status && res.status === 200) {
          enqueueSnackbar("User details updated successfully.", {
            variant: "success",
          });
        }
      })
      .then((_) => {
        navigate(`${rolesViewUrl}/${id}`);
      })
      .catch((err) => {
        return enqueueSnackbar(`${err.response.data.apiErrors[0].cause}`, {
          variant: "error",
        });
      });
  };

  const handleChange = (event) => {
    const { value, name } = event.target;
    switch (name) {
      case "name":
        setName(value);
        break;
      default:
        enqueueSnackbar(`Unknown field : ${event.target.name}`, {
          variant: "error",
        });
    }
  };

  const handlePermissionChange = (event) => {
    const {
      target: { value },
    } = event;

    let duplicateRemoved = [];

    value.forEach((item) => {
      if (duplicateRemoved.findIndex((o) => o === item) >= 0) {
        duplicateRemoved = duplicateRemoved.filter((x) => x === item);
      } else {
        duplicateRemoved.push(item);
      }
    });
    setPermissionName(duplicateRemoved);
  };

  // Get all permissions
  // Get role's current permissions.

  const getPrePopulatedFields = () => {
    let permissionNames = [];

    setLoading(true);

    axios
      .get(`${REACT_APP_BASE_API_URL}/${permissionsEndpoint}`)
      .then((res) => {
        const { result } = res.data;
        result.map((app) => {
          app.permissions.map((permission) =>
            permissionNames.push(permission.perm)
          );
        });
      });

    axios
      .get(`${REACT_APP_BASE_API_URL}/${endpoint}/${id}`)
      .then((res) => {
        const { result } = res.data;
        setName(result.role_name);

        return result;
      })
      .then((result) => {
        let updatedUserPerms = [];

        _.map(result.permissions, (p) => {
          updatedUserPerms.push(p.perm);
        });

        setPermissionName(updatedUserPerms);
      })
      .then((_) => setLoading(false));

    setPermissions(permissionNames);
  };

  React.useEffect(() => {
    // getPrePopulatedFields();
    let permissionNames = [];

    setLoading(true);

    axios
      .get(`${REACT_APP_BASE_API_URL}/${permissionsEndpoint}`)
      .then((res) => {
        const { result } = res.data;
        result.map((app) => {
          app.permissions.map((permission) =>
            permissionNames.push(permission.perm)
          );
        });
      });

    axios
      .get(`${REACT_APP_BASE_API_URL}/${endpoint}/${id}`)
      .then((res) => {
        const { result } = res.data;
        setName(result.role_name);

        return result;
      })
      .then((result) => {
        let updatedUserPerms = [];

        _.map(result.permissions, (p) => {
          updatedUserPerms.push(p.perm);
        });

        setPermissionName(updatedUserPerms);
      })
      .then((_) => setLoading(false));

    setPermissions(permissionNames);
  }, []);

  return (
    <React.Fragment>
      {loading ? (
        "LOADING..."
      ) : (
        <Box mt={2} component="form" onSubmit={updateRole}>
          <FormGroup>
            <TextField
              fullWidth
              required
              margin="dense"
              id="name"
              name="name"
              label="name"
              variant="outlined"
              defaultValue={name}
              onChange={handleChange}
            />

            <FormControl fullWidth sx={{ mb: 1 }}>
              <InputLabel id="permissions">Permissions</InputLabel>
              <Select
                labelId="permissions"
                id="permissions"
                name="permissions"
                multiple
                value={permissionName}
                onChange={handlePermissionChange}
                input={<OutlinedInput label="Permissions" />}
                renderValue={(selected) =>
                  _.toString(selected).length > 30
                    ? _.join(selected, ", ").slice(0, 33).concat("...")
                    : selected.map((x) => x).join(", ")
                }
                MenuProps={MenuProps}
              >
                {permissions.map((permission, index) => (
                  <MenuItem key={index} value={permission}>
                    <Checkbox
                      checked={
                        permissionName.findIndex(
                          (item) => item === permission
                        ) >= 0
                      }
                    />
                    <ListItemText primary={permission} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* --- */}

            <Grid item sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="outlined"
                startIcon={<CheckIcon />}
                type="submit"
                color="primary"
                sx={{ m: 1 }}
              >
                Save
              </Button>

              <Button
                variant="outlined"
                startIcon={<CancelIcon />}
                color="primary"
                sx={{ m: 1 }}
                onClick={() => navigate(`${rolesViewUrl}`)}
              >
                Cancel
              </Button>
            </Grid>
          </FormGroup>
        </Box>
      )}
    </React.Fragment>
  );
}
